export default __webpack_public_path__ + "static/media/visa.84fb2132.svg";